// extracted by mini-css-extract-plugin
export default {"action-btn":"ResetPasswordPage_action-btn__0GQsx","message-header":"ResetPasswordPage_message-header__12Ab5","message-subtitle":"ResetPasswordPage_message-subtitle__pUXtM"};